<template>
  <!-- Start Footer Area -->
  <footer class="footer-area bg-f7fafd">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <div class="logo">
              <!-- <a href="/"> -->
              <img
                src="../../assets/heartbeatfamlogo.png"
                alt="HeartBeatFam Logo"
                width="80"
                height="80"
              />
              <!-- </a> -->
            </div>
            <p style="color: white">
              Built with ❤️ in Athens (GA) and Beverly Hills (CA) by family for
              family
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget pl-lg-5">
            <h3>Company</h3>
            <ul class="list">
              <li v-if="false">
                About Us
              </li>
              <li @click="handleDiscoverClick">
                Discover
              </li>
              <li @click="handleBlogClick">
                Our Blog
              </li>
              <li v-if="!config.isBeta" @click="handlePricingClick">
                Pricing
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget pl-lg-5">
            <h3>Support</h3>
            <ul class="list">
              <li @click="handlePolicyClick('privacy')">
                Privacy
              </li>
              <li @click="handlePolicyClick('terms')">
                Terms and Conditions
              </li>
              <li @click="handlePolicyClick('data')">
                Data and Cookie Policy (GDPR)
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <h3>Address</h3>
            <ul class="footer-contact-info">
              <li>
                A Pony Engine International Inc. Company
              </li>
              <li>
                9461 Charleville Blvd. #888
              </li>
              <li>Beverly Hills, CA 90212</li>
              <li>
                Email:
                <a href="mailto:savalas@heartbeatfam.com">
                  family@heartbeatfam.com</a
                >
              </li>
              <li>
                Phone:
                <a href="tel:+5595120719">+ (559) 512-0719</a>
              </li>
            </ul>
            <social-link-share />
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="copyright-area">
            <p>Copyright &copy;2024 HeartBeatFam. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>

    <img src="@/assets/img/map.png" class="map" alt="map" />
    <back-to-top bottom="50px" right="50px">
      <div class="go-top" />
    </back-to-top>
  </footer>
  <!-- End Footer Area -->
</template>
<script>
import BackToTop from "vue-backtotop";
import config from "@/assets/_config.json";
import SocialLinkShare from "@/components/common/socialLinkShare";

export default {
  name: "Footer",
  components: {
    BackToTop,
    SocialLinkShare
  },
  data() {
    return {
      config
    };
  },
  methods: {
    handleDiscoverClick() {
      this.$router.push("/myapps");
    },
    handleBlogClick() {
      this.$router.push("/blog");
    },
    handlePricingClick() {
      this.$router.push("/pricing");
    },
    handlePolicyClick(policyType) {
      this.$router.push(`/policy/${policyType}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-area {
  position: relative;
  z-index: 1;
  padding-top: 80px;
  background-color: #8d57e6;
  font-family: "Lato", sans-serif;
}

.footer-area .map {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  z-index: -1;
  bottom: 0;
  opacity: 0.7;
}

.single-footer-widget .logo {
  margin-bottom: 20px;
  text-align: center;
}

.single-footer-widget .logo a {
  display: block;
}

.single-footer-widget h3 {
  font-size: 18px;
  margin-bottom: 30px;
  color: #a9f5c3;
}

.single-footer-widget ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  color: #f3f5f6;
}

.single-footer-widget ul.list li {
  margin-bottom: 10px;
  cursor: pointer;
}

.single-footer-widget ul.list li a {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.single-footer-widget ul.list li a:hover {
  color: #557efb;
  padding-left: 7px;
}

.single-footer-widget ul.list li:last-child {
  margin-bottom: 0;
}

.single-footer-widget ul.footer-contact-info {
  margin-bottom: 20px;
}

.single-footer-widget ul.footer-contact-info li {
  position: relative;
  color: #ffffff;
  margin-bottom: 8px;
}

.single-footer-widget ul.footer-contact-info li i {
  position: absolute;
  left: 0;
  width: 15px;
  top: 5px;
}

.single-footer-widget ul.footer-contact-info li:last-child {
  margin-bottom: 0;
}

.single-footer-widget ul.footer-contact-info li a {
  color: #ffffff;
}

.single-footer-widget ul.footer-contact-info li a:hover {
  color: #557efb;
}

.copyright-area {
  margin-top: 80px;
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid #d8ebfd;
  text-align: center;
  color: white;
}
@media (max-width: 640px) {
  .single-footer-widget h3 {
    margin-bottom: 12px;
    margin-top: 20px;
  }
}
</style>
